'use client';

import TurnstileWidget from '@/components/apartments/TurnstileWidget';

/**
 * Wrapper compartido del widget Cloudflare Turnstile (modo Gestionado del
 * dashboard). Punto único de entrada para los flujos de pago; el widget
 * subyacente sigue viviendo en components/apartments/TurnstileWidget.
 */
export function TurnstileGate({ onToken, language = 'auto' }: { onToken: (token: string | null) => void; language?: 'es' | 'en' | 'auto' }) {
  return <TurnstileWidget onToken={onToken} language={language} />;
}
